import { render, staticRenderFns } from "./YearsClients.vue?vue&type=template&id=7a953fbc&"
import script from "./YearsClients.vue?vue&type=script&lang=js&"
export * from "./YearsClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports